import { Pagination } from "../../../../model/pagination";
import { IOfficialDiaryPagedRequest } from "../../../../model/sdp/official-daily/request/official-diary-paged-request";
import HttpClient from "../../../services/http-client";
import { IOfficialDiaryPagedResponse } from "../../../../model/sdp/official-daily/response/official-diary-paged-response";
import { IOfficialDiaryDetailResponse } from "../../../../model/sdp/official-daily/response/official-diary-detail-response";
import { FileBase64 } from "../../../../model/file-base-64";
import { ICategoryPublicationResponse } from "../../../../model/sdp/official-daily/response/category-publication-response";
import { ISubCategoryPublicationResponse } from "../../../../model/sdp/official-daily/response/subcategory-publication-response";
import { IEntityPublicationResponse } from "../../../../model/sdp/official-daily/response/entity-publication-response";
import { IPreviewPublicationRequest } from "../../../../model/sdp/official-daily/request/preview-publication-request";
import { serialize } from 'object-to-formdata';
import { IPreviewPublicationResponse } from "../../../../model/sdp/official-daily/response/preview-publication-response";
import { IConfirmPublicationRequest } from "../../../../model/sdp/official-daily/request/confirm-publication-request";

const defaultPath = 'OfficialDiary';

const get = async (params: IOfficialDiaryPagedRequest): Promise<Pagination<IOfficialDiaryPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: params
    }).then((response) => Object.assign(new Pagination<IOfficialDiaryPagedResponse>(), response.data));
};

const getById = async (id: number): Promise<IOfficialDiaryDetailResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => Object.assign({} as IOfficialDiaryDetailResponse, response.data));
};

const downloadFile = async (id: number): Promise<FileBase64> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}/File/Download`
    }).then((response) => Object.assign(new FileBase64(), response.data));
};

const listCategories = async (): Promise<ICategoryPublicationResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/categories`
    }).then((response) => Object.assign([] as unknown as ICategoryPublicationResponse, response.data));
};
const listEntityPublication = async (): Promise<IEntityPublicationResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/entityPublication`
    }).then((response) => Object.assign([] as unknown as IEntityPublicationResponse, response.data));
};

const listSubcategories = async (id: number): Promise<ISubCategoryPublicationResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/subcategories`,
        params: { categoryId: id }
    }).then((response) => Object.assign([] as unknown as ISubCategoryPublicationResponse, response.data));
};
const releasePublication = async (clientId: number) => {
    await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Publication/Release`,
        params: { clientId },
        cancelToken: undefined
    });
}

const close = async (officialDailyId: number) => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${officialDailyId}/Close`
    });
}

const changeVisibility = async (officialDailyId: number) => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${officialDailyId}/ChangeVisibility`
    });
}

const previewPublication = async (params: IPreviewPublicationRequest, files: File[]): Promise<IPreviewPublicationResponse> => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });


    files.forEach(file => {
        formData.append("files", file);
    });

    return await HttpClient.executeRequest({
        method: 'post',
        data: formData,
        url: `/${defaultPath}/Publication/Preview`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then((response) => Object.assign({} as IPreviewPublicationResponse, response.data));
};

const confirmPublication = async (params: IConfirmPublicationRequest) => {
    await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/Publication/Confirm`,
        data: params,
    });
};


const OfficialDiaryAppService = {
    get, getById, downloadFile, listCategories, close, changeVisibility, listSubcategories, listEntityPublication, confirmPublication, previewPublication, releasePublication
};

export default OfficialDiaryAppService;